// extracted by mini-css-extract-plugin
export default {"img":"App_img__aGVwe","container":"App_container__4L7Vo","footerLabel":"App_footerLabel__F3IQV","mainRow":"App_mainRow__9eACE"};